export const BRAND_NAME = "E-NGO";
